/**
 * persist changes inside \AskNicely\Billing\BillingService
 * persist changes inside \AskNicely\Billing\BillingService::isVisibleOnPlan
 * persist changes inside @see \AskNicely\Company\CompanyController::getVisibleOnPlan.
 */

export enum BillingStarterPlanVisibility {
    CROSSTABS = 'CROSSTABS',
    CASE_MANAGEMENT = 'CASE_MANAGEMENT',
    REPLY_TEMPLATES = 'REPLY_TEMPLATES',
    MANUAL_WORKFLOWS = 'MANUAL_WORKFLOWS',
    PERFORMANCE_AND_RECOGNITION = 'PERFORMANCE_AND_RECOGNITION',
    DOWNLOAD_RESPONSES = 'DOWNLOAD_RESPONSES',
    PUBLISH_RESPONSES = 'PUBLISH_RESPONSES',
    SURVEY_CUSTOMISE = 'SURVEY_CUSTOMISE',
    SETTINGS_API = 'SETTINGS_API',
    SETTINGS_EMAIL_DOMAIN = 'SETTINGS_EMAIL_DOMAIN',
    SETTINGS_DATA_CUSTOM_GROUPS = 'SETTINGS_DATA_CUSTOM_GROUPS',
    SETTINGS_TESTIMONIALS = 'SETTINGS_TESTIMONIALS',
    SETTINGS_USERS_MICROSOFT = 'SETTINGS_USERS_MICROSOFT',
    SETTINGS_USERS_OKTA = 'SETTINGS_USERS_OKTA',
    SETTINGS_USERS_SAML = 'SETTINGS_USERS_SAML',
    SETTINGS_USERS_SCIM = 'SETTINGS_USERS_SCIM',
    SETTINGS_ACCOUNT = 'SETTINGS_ACCOUNT',
}

export interface IBillingStarterPlanVisibility {
    CROSSTABS?: boolean,
    CASE_MANAGEMENT?: boolean,
    REPLY_TEMPLATES?: boolean,
    MANUAL_WORKFLOWS?: boolean,
    PERFORMANCE_AND_RECOGNITION?: boolean,
    DOWNLOAD_RESPONSES?: boolean,
    PUBLISH_RESPONSES?: boolean,
    SURVEY_CUSTOMISE?: boolean,
    SETTINGS_API?: boolean,
    SETTINGS_EMAIL_DOMAIN?: boolean,
    SETTINGS_DATA_CUSTOM_GROUPS?: boolean,
    SETTINGS_TESTIMONIALS?: boolean,
    SETTINGS_USERS_MICROSOFT?: boolean,
    SETTINGS_USERS_OKTA?: boolean,
    SETTINGS_USERS_SAML?: boolean,
    SETTINGS_USERS_SCIM?: boolean,
    SETTINGS_ACCOUNT?: boolean,
}
export function isVisibleOnPlan(instance: any & { visibleOnPlan: IBillingStarterPlanVisibility }, key: string): boolean {
    return instance.visibleOnPlan && key in instance.visibleOnPlan && instance.visibleOnPlan[key]
}
